<template>
  <div
    v-if="mappedAttributes.length"
    class="visnet-events__filters-bar"
    :class="{ collapsed: showCollapse }"
  >
    <div class="visnet-events__filters-bar-head" @click="changeCollapse">
      <span>Filters</span>
      <a
        :class="{ collapsed: showCollapse }"
        aria-controls="collapse"
        :aria-expanded="showCollapse"
        @click="changeCollapse"
      >
        <div v-if="!showCollapse" @click="changeCollapse"><Icon name="chevron-down" /></div>
        <div v-else @click="changeCollapse">hide filters <Icon name="chevron-up" /></div>
      </a>
    </div>
    <b-collapse id="collapse" v-model="showCollapse" class="visnet-events__filters-bar-body">
      <AttributesButtons :selected-chart="selectedChart" :attributes="mappedAttributes" />
    </b-collapse>
  </div>
</template>

<script>
import AttributesButtons from '@/components/substations/visnet-hubs/main-view/phases-feeders/phases-feeders-attributes-buttons';
import { mapGetters } from 'vuex';

export default {
  name: 'AttributesFiltration',
  components: { AttributesButtons },
  props: {
    selectedChart: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showCollapse: true
    };
  },
  computed: {
    ...mapGetters({
      electricalAttributes: 'electricalData/electricalAttributes',
      powerQualityAttributes: 'powerQualityData/powerQualityAttributes'
    }),
    mappedAttributes() {
      return this.selectedChart === 'ElectricalFiltration'
        ? this.electricalAttributes
        : this.powerQualityAttributes;
    }
  },
  watch: {
    showCollapse() {
      this.$emit('scrollWindow');
    }
  },
  methods: {
    changeCollapse() {
      this.showCollapse = !this.showCollapse;
    }
  }
};
</script>
